import { render } from "./ImportanceTwo.vue?vue&type=template&id=7b118051"
const script = {}

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__